// heavily based on example code here https://github.com/Workday/canvas-kit/tree/master/modules/react/button#basebutton
import * as React from 'react';
import styles from './group-button.module.scss';
import classNames from 'classnames';
import { BaseButton } from '@workday/canvas-kit-react/button';

const getGroupButtonColors = () => {
    return {
        default: {
            background: '#FFF',
            label: 'var(--cnvs-base-palette-licorice-500)',
            icon: 'var(--cnvs-base-palette-licorice-500)'
        },
        hover: {
            background: 'rgba(217, 217, 217, 0.2)',
            label: 'var(--cnvs-base-palette-licorice-500)',
            icon: 'var(--cnvs-base-palette-licorice-500)'
        },
        active: {
            background: 'var(--cnvs-base-palette-plum-100)',
            label: 'var(--cnvs-base-palette-blueberry-500)',
            icon: 'var(--cnvs-base-palette-blueberry-500)'
        },
        focus: {
            background: 'rgba(217, 217, 217, 0.2)',
            label: 'var(--cnvs-base-palette-licorice-500)',
            icon: 'var(--cnvs-base-palette-licorice-500)'
        },
        disabled: {
            background: 'var(--cnvs-base-palette-blueberry-400)'
        }
    };
};

const getActiveGroupButtonColors = () => {
    return {
        ...getGroupButtonColors(),
        default: getGroupButtonColors().active,
        focus: getGroupButtonColors().active,
        hover: {
            background: 'var(--cnvs-base-palette-plum-200)',
            label: 'var(--cnvs-base-palette-blueberry-600)',
            icon: 'var(--cnvs-base-palette-blueberry-600)'
        }
    };
};

export type GroupButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    onGroupButtonClick: (groupName: string) => void;
    isToggled?: boolean;
    icon?: any;
};

export const GroupButton = ({
    children,
    onGroupButtonClick,
    isToggled = false,
    icon,
    ...elemProps
}: GroupButtonProps) => {
    const onClick = () => {
        onGroupButtonClick(String(children));
    };

    return (
        <BaseButton
            title={String(children)}
            onClick={onClick}
            className={classNames(styles.groupButton, icon ? null : styles.groupButtonNoIcon)}
            colors={isToggled ? getActiveGroupButtonColors() : getGroupButtonColors()}
            size='medium'
            type='button'
            grow={true}
            {...elemProps}>
            {icon && <BaseButton.Icon icon={icon} style={{ marginLeft: '4px', marginRight: 0 }} />}
            <BaseButton.Label>{children}</BaseButton.Label>
        </BaseButton>
    );
};
